import Close from '../../../../../component/close/Close';
import * as css from './SystemMessageTopPopup.css';

function SystemMessageTopPopup({closePop, title}) {
    return (
        <css.popUpTop data-cy={'systemMessagePopUpTop'}>
            <css.popTitle>{title}</css.popTitle>
            <Close onClick={closePop} className={'pop'}/>
        </css.popUpTop>
    );
}

export default SystemMessageTopPopup;

